// extracted by mini-css-extract-plugin
export default {"chartWrapper":"mediaChart_chartWrapper__BW5HE"};